import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";
import { gameImages } from "../generated/games.generated";
import { resolveLogoUrl } from "../modules/accountLogos";

import _ from "lodash";

const useStyles = makeStyles(() => ({
  gamePickerDiv: { display: "flex", flexDirection: "column", justifyContent: "flex-start", flex: 1 }
}));

let images = gameImages;

/**
 *
 * @param props.items {Array}
 * @param props.setSelectedItem {Function}
 * @returns {JSX.Element}
 * @constructor
 */
export default function SelectorGame(props) {
  const [value, setValue] = useState(_.get(props, "value"));
  const classes = useStyles();
  if (props.items === undefined) return null;
  return (
    <div id="selectorGame" className={classes.gamePickerDiv}>
      {props.items.map((game) => {
        return (
          <div
            id={game.title}
            key={game._id}
            style={{ backgroundColor: game._id === value ? "hsla(128,0%,50%,0.5)" : "hsla(128,0%,50%,0)" }}
          >
            <Avatar
              id="selectorGame_avatar"
              className={props.classes.avatarSmall}
              key={String(game._id)}
              src={game.image && game.image.startsWith("/images/") ? resolveLogoUrl(game.image) : images[String(game._id)]}
              title={game.title}
              onClick={() => {
                if (!_.isNil(props.selectedVersion) && !_.isNil(_.get(props, "selectedVersion._id")) && props.userPermissions["editContent"]) {
                  const persist =
                    typeof props.persistVersionBeforeSwitch === "function"
                      ? props.persistVersionBeforeSwitch(props.selectedVersion)
                      : Promise.resolve();

                  persist
                    .then(() => {
                      setValue(game._id);
                      props.setValue(game);
                    })
                    .catch((err) => {
                      console.error(err);
                      setValue(game._id);
                      props.setValue(game);
                    });
                } else {
                  setValue(game._id);
                  props.setValue(game);
                }
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
